const geminiHost = 'generativelanguage.googleapis.com'

/**
 * Create Gemini API request function
 * @param {Function} httpRequest - HTTP request function
 * @returns {Function} requestAPI function bound to the httpRequest
 */
export function createRequestAPI(httpRequest) {
  return async ({
    host = geminiHost,
    path,
    method = 'POST',
    body = {},
    apiKey,
    timeout = 60000,
  }) => {
    if (!apiKey) {
      throw new Error('apiKey is required for Gemini API calls')
    }

    // Gemini uses query parameter for API key
    const pathWithKey = path.includes('?')
      ? `${path}&key=${apiKey}`
      : `${path}?key=${apiKey}`

    const options = {
      protocol: 'https',
      options: {
        host,
        path: pathWithKey,
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout,
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
    }

    const resp = await httpRequest(options)

    if (resp.statusCode >= 400) {
      throw new Error(
        `Gemini API error: ${resp.statusCode} - ${JSON.stringify(resp.body)}`,
      )
    }

    return JSON.parse(resp.body)
  }
}
